(ns minorodata.components.log.core
  (:require [minorodata.app.handlers :refer [dispatch dispatch-sync]]
            [minorodata.components.log.controls :as log.controls]
            [minorodata.components.log.table :as log.table]
            [minorodata.components.spinner.core :as spinner]
            [minorodata.logs.model :refer [->logs-view]]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            [ui.page :refer [page-content page-controls page-header page-root
                             page-title]]))


(def noop
  (constantly nil))


(defn logs-spinner []
  (let [loading-logs?       @(re-posh/subscribe [:mold-http/loading? :logs.api/fetch])
        loading-sources?    @(re-posh/subscribe [:mold-http/loading? :connections.api/fetch-sources])
        loading-connectors? @(re-posh/subscribe [:mold-http/loading? :connections.api/fetch-user-connectors])

        loading?            (or loading-logs? loading-sources? loading-connectors?)]

    [spinner/full-screen {:open loading?}]))


(defn init-state []
  (let [{:app-route/keys [name params query]} @(re-posh/subscribe [:app-route/pull])
        config        @(re-posh/subscribe [:logs.misc/load-initial-config])
        initial-state (if (seq query) query config)]
    (when (not-empty (dissoc config :page))
      (dispatch [:app.events/navigate name params initial-state]))
    (dispatch [:logs-view/add (->logs-view initial-state)])
    (dispatch [:logs.events/save-config-to-local-storage])))

(defn page []
  [page-root
   [page-header {:class   "-top-12 left-0 z-20"
                 :variant :border}
    [page-title "Logs"]
    [page-controls
     [log.controls/controls]]]
   [page-content {:variant :border
                  :class   "overflow-visible"}
    [log.table/logs-table]]])

(defn logs-page []
  (let [last-query (reagent/atom nil)]
    (reagent/create-class
     {:constructor
      (fn []
       ;; Needed to have a full list of sources ready
        (dispatch [:connections.api/fetch-user-connectors])

       ;; Needed for groupining in the log types list
        (dispatch [:connections.api/fetch-sources])

        (init-state)
        (dispatch [:logs.api/fetch])
        (dispatch [:logs.api/fetch-pagination]))

      :component-did-update
      (fn []
        (let [query @(re-posh/subscribe [:app-route/prop :app-route/query])]
          (when (not= query @last-query)
            (dispatch [:logs-view/update (->logs-view query)
                       {:replace true}])
            (dispatch [:logs.api/fetch])
            (dispatch [:logs.api/fetch-pagination])
            (reset! last-query query)
            (dispatch-sync [:logs.events/save-config-to-local-storage]))))

      :component-will-unmount
      (fn []
        (dispatch-sync [:logs-view/delete]))

      :render
      (fn []
        [:<>
         [page]])})))
